import { utils, writeFile } from 'xlsx';

import {
  ENCUMBRANCE_EXCEL_HEADERS,
  ENCUMBRANCE_EXCEL_SHEET_NAME,
} from '../constants/encumbranceExcelColumns';

const SAMPLE_ROWS = [
  [
    'ENC001',
    'CO_OWNERSHIP',
    1,
    100,
    100,
    '15/01/2024',
    '',
    '12345678A',
    'Juan Pérez',
    'HOLDER',
    '',
    '',
    '',
    '',
    'Proindiviso',
  ],
  [
    'ENC001',
    'CO_OWNERSHIP',
    1,
    100,
    100,
    '15/01/2024',
    '',
    '12345678A',
    'Juan Pérez',
    'CO_OWNER',
    '87654321B',
    'María López',
    '',
    50,
    '',
  ],
  [
    'ENC002',
    'USUFRUCT',
    101,
    200,
    100,
    '01/03/2023',
    '31/12/2025',
    '11111111A',
    'Carlos García',
    'HOLDER',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ENC002',
    'USUFRUCT',
    101,
    200,
    100,
    '01/03/2023',
    '31/12/2025',
    '11111111A',
    'Carlos García',
    'USUFRUCTUARY',
    '22222222B',
    'Ana Martín',
    '',
    100,
    '',
  ],
  [
    'ENC003',
    'PLEDGE_OR_GUARANTEE',
    201,
    300,
    100,
    '10/06/2022',
    '10/06/2026',
    '33333333C',
    'Pedro Sánchez',
    'HOLDER',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'ENC003',
    'PLEDGE_OR_GUARANTEE',
    201,
    300,
    100,
    '10/06/2022',
    '10/06/2026',
    '33333333C',
    'Pedro Sánchez',
    'CREDITOR',
    '',
    'Banco Ejemplo S.A.',
    '',
    '',
    'Pignoración de ejemplo',
  ],
];

export const downloadEncumbrancesExcelTemplate = (): void => {
  const worksheet = utils.aoa_to_sheet([
    [...ENCUMBRANCE_EXCEL_HEADERS],
    ...SAMPLE_ROWS,
  ]);
  const workbook = utils.book_new();

  utils.book_append_sheet(workbook, worksheet, ENCUMBRANCE_EXCEL_SHEET_NAME);
  writeFile(workbook, 'plantilla-cargas-masivas.xlsx');
};
